module.exports = __webpack_public_path__ + "img/baoxian10.d56eab8c.png";